import { Vendor } from '../model/vendor.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { SelectItem } from '../model/common.model';
import { ReceivedItemSearch, ReceivedItemH, CancelReceivedItemModel } from '../model/item-received.model';
import { User } from '../model/user.model';


const API_URL = environment.apiUrl;
const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class ItemReceivedService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));

        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/receiveditem';


    }

    GetReceivedItemList(search: ReceivedItemSearch): Observable<ReceivedItemH[]> {
        return this.http.post<ReceivedItemH[]>(this.Url + '/GetReceivedItemList/', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    } 

    GetReceivedItemForExport(search: ReceivedItemSearch, type: number): Observable<any> {

        return this.http.post(this.Url + '/GetItemReceiveForExport/' + type, search, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                
            }),
            responseType: 'arraybuffer'
        }).pipe(tap((x) => {
        }),
            catchError(this.handleError<ReceivedItemSearch>('SearchWorkPermit'))
            );
    }
    

    CancelReceivedItem(search: CancelReceivedItemModel): Observable<any> {
        return this.http.post<any>(this.Url + '/CancelReceivedItem/', search, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched GetItemDetailByID`);
                })
            );
    }

    getItemReceivedById(Id: number): Observable<ReceivedItemH[]> {
        return this.http.get<ReceivedItemH[]>(this.Url + "/GetReceivedItemDetailByID/" + Id.toString(), httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }



    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}


// WEBPACK FOOTER //
// ./src/app/services/item-received.service.ts